
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gNG10Ozr4LLyI_Q9z53nQPXbBmiorHLEJkCTZ4HCdQmgMeta } from "/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexKy7mgJmyTQyRjsMNyk2SmoHta9QrEVRtGqckxIvA2i0Meta } from "/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchKBO_GVyRni_45x4NFVO5hacoKe4M_6a8L2Zpv2yQiRzIIMeta } from "/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexrxHiBjVdHj152bvv_45_Dq3vFDDZ6pa27WwXoG_BZJzA0Meta } from "/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_9341shD16vSCwErAD6py7NiJAZ5xBcNKNrt3ZP1WdTfUUMeta } from "/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index2NfYCbiCNKk4i5ftp4WYWpC2G_xbUrwqggiDRVf6VYIMeta } from "/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93qHvcX4jAPWlch9pXm_45hKarJSASgM01f7ERbCzsQbFJAMeta } from "/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexu0I6ZEzdToyaqUagsPvNQFNqRzQfC560w3FXOmhkLSYMeta } from "/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93kVxTWU1JBR6NXFCLzOzGXiyc7yWsyUMg4gE_cU_45ZD00Meta } from "/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexlEwYN47BEIF45UjtFeY_vSC12qHv8lJ_458K_45pSvwqbA8Meta } from "/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexBa_rBxaBSBjDTgvEuofGd7DCOK7ftWRfM5rwqqlQ79kMeta } from "/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index2NfYCbiCNKk4i5ftp4WYWpC2G_xbUrwqggiDRVf6VYIMeta || {},
    component: () => import("/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexu0I6ZEzdToyaqUagsPvNQFNqRzQfC560w3FXOmhkLSYMeta || {},
    component: () => import("/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexlEwYN47BEIF45UjtFeY_vSC12qHv8lJ_458K_45pSvwqbA8Meta || {},
    component: () => import("/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexBa_rBxaBSBjDTgvEuofGd7DCOK7ftWRfM5rwqqlQ79kMeta || {},
    component: () => import("/codebuild/output/src3679639798/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]